import { HttpClient } from '@angular/common/http';

import { EMPTY, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

import { SntI18nModuleConfig } from './config';

export class PruneTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private config: SntI18nModuleConfig,
  ) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    return this.http
      .get<Record<string, string>>(`${this.config.prefix}${lang || this.config.defaultLang}${this.config.suffix}`)
      .pipe(
        map(this._prune),
        catchError((errorResponse) => {
          if (errorResponse.url.includes(`${this.config.defaultLang}${this.config.suffix}`)) return EMPTY;

          return this.getTranslation(this.config.defaultLang as string);
        }),
      );
  }

  private _prune(translations: Record<string, string>) {
    Object.keys(translations).forEach((key) => {
      if (!translations[key]) {
        delete translations[key];
      }
    });

    return translations;
  }
}
